import { render, staticRenderFns } from "./PlaylistSearch.vue?vue&type=template&id=d4356436&"
import script from "./PlaylistSearch.vue?vue&type=script&lang=js&"
export * from "./PlaylistSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports